export const exportAdvancesExcelUrl = "/payment/exportAdvancesExcel/{date}";
export const getAdvancesForDateUrl = "/payment/getAdvancesByDay/{day}";
export const cancelAdvanceUrl = "/payment/cancelAdvance";
